import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Grid, Paper, Alert, CircularProgress } from "@mui/material";
import { useMediaQuery, useTheme } from "@mui/material";
import logo from '../../Assets/imgs/logo.png';
import './LoginPage.css';

// Local testing only: SSO cannot redirect back to localhost. NODE_ENV is fixed to
// 'production' at build time, so this is always false (and stripped) in deployed builds.
const DEV_LOGIN_ENABLED = process.env.NODE_ENV === 'development' && process.env.REACT_APP_DEV_LOGIN === 'true';

const LoginPage = ({ onLogin }) => {
  const [openAlert, setOpenAlert] = useState(false);
  const [isProcessing, setIsProcessing] = useState(true);
  const backendURL = process.env.REACT_APP_TWCHATBOT_DOMAINS;
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const isSmScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [idToken, setIdToken] = useState(null);
  // Handle token processing
  useEffect(() => {
    const processToken = async () => {
      setIsProcessing(true);
      // First check URL parameters
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("id_token");
      if (token) {
        setIdToken(token);
        localStorage.setItem('token', token);
        window.history.replaceState({}, document.title, "/");
        await fetchProtectedData(token);
      } else {
        // Check localStorage if no URL token
        const storedToken = localStorage.getItem('token');
        if (storedToken) {
          setIdToken(storedToken);
          await fetchProtectedData(storedToken);
        } else {
          setIsProcessing(false);
        }
      }
    };

    processToken();
  }, []);

  const fetchProtectedData = async (tokenToUse) => {
    if (!tokenToUse) {
      setIsProcessing(false);
      return;
    }
    try {
      const response = await fetch(`${backendURL}/api/protected/`, {
        headers: { Authorization: `Bearer ${tokenToUse}` }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch');
      }
      const data = await response.json();
      localStorage.setItem('sr_id',data.user.sr_id)
      onLogin({ fullname: data.user.name, email: data.user.preferred_name });
    } catch (error) {
      console.error("Error fetching protected data:", error);
      localStorage.removeItem('token');
      setIdToken(null);
      setOpenAlert(true);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleSubmit = () => {
    console.log("inside handler submit")
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    setIdToken(null);
    console.log("Id token set to null")
    document.cookie = "id_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
    console.log("About to hit backend")
    window.location.href = `${backendURL}/api/auth/login/`;
    console.log("login done")
  };
  // Show loading while processing token
  if (isProcessing) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </div>
    );
  }

  // Only render login page if not processing and no valid token
  return (
    <div>
      <div className='login-form-container'>
        <Grid className="form-container">
          <Grid item xs={10} sm={8} md={6} lg={4}>
            <Paper elevation={0} style={{ textAlign: 'center', backgroundColor: 'transparent' }}>
              <p className='greeting'>Hello, Welcome to Nudge</p>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                size="large"
                className='custom-button'
                onClick={handleSubmit}
              >
                Sign-in with SSO
              </Button>
              {DEV_LOGIN_ENABLED && (
                <Button
                  variant="outlined"
                  fullWidth
                  size="large"
                  sx={{ marginTop: 2, textTransform: 'none', fontFamily: 'Kumbh Sans' }}
                  onClick={() => onLogin({
                    fullname: process.env.REACT_APP_DEV_USER_NAME || 'Local Developer',
                    email: process.env.REACT_APP_DEV_USER_EMAIL || 'local.dev@techwave.com',
                  })}
                >
                  Continue without SSO (local dev)
                </Button>
              )}
              {openAlert && (
                <Alert
                  onClose={() => setOpenAlert(false)}
                  severity="error"
                  sx={{ marginTop: 2 }}
                >
                  Failed to login. Please try again...
                </Alert>
              )}
            </Paper>
          </Grid>
        </Grid>
      </div>
      {/* <div className="ai-partner">
        <span style={{ color: 'black' }}>Powered by </span>
        <a href="https://techwave.net/" target="_blank" rel="noopener noreferrer" className="techwave-link">
          <img src={logo} alt='techwave-logo' style={getLogoSize()} />
        </a>
      </div> */}
    </div>
  );
};

export default LoginPage;